import templateUrl from 'emun.report/quick-report-params.htm'
import QuickReportPromptController from 'emun.report/quick-report-params.controller'
//import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const QuickReportPrompt = {
  open(options) {
    return modals.open(angular.extend({
      size: 'lg',
      templateUrl,
      resolve: {
        options: () => options
      },
      bindToController: true,
      controller: QuickReportPromptController,
      controllerAs: '$ctrl'
    }, (options || {}).modal)).result;
  }
};

export default QuickReportPrompt;